<div class="row">
    <div class="col-sm-8 col-12">
        <h1>Pesquisa Aditivos em Análise</h1>
    </div>
</div>

<form>
    <div class="card">
        <div class="card-body">
            <div class="row" *ngIf="!exibePesquisaAvancada">
                <div class="col-sm-12 col-12">
                    <h6 class="mb-0">Critério</h6>
                    <input class="col-12" [(ngModel)]="criterio" name="criterio" autofocus>
                </div>
            </div>

            <div *ngIf="exibePesquisaAvancada">
                <div class="row">
                    <div class="col-sm-3 col-12">
                        <h6 class="mb-0">Instituição Financeira</h6>
                        <input class="col-12" [(ngModel)]="instituicaoFinanceira" name="criterioInstituicaoFinanceira">
                    </div>
                    <div class="col-sm-7 col-12">
                        <h6 class="mb-0">Período Protocolo</h6>
                        <div class="row">
                            <div class="col-sm-6 col-12">
                                <bn-datepicker [(ngModel)]="criterioDatProtocoloInicio"
                                               name="criterioDatProtocoloInicio"></bn-datepicker>
                            </div>
                            <div class="col-sm-6 col-12">
                                <bn-datepicker [(ngModel)]="criterioDatProtocoloFim"
                                               name="criterioDatProtocoloFim"></bn-datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2 col-12">
                        <h6 class="mb-0">PAC</h6>
                        <input class="col-12" [(ngModel)]="criterioPac" name="criterioPac">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2 col-12">
                        <h6 class="mb-0">Situação</h6>
                        <select [(ngModel)]="criterioSituacao" class="col-12" name="criterioSituacao">
                            <option value="null"></option>
                            <option value="Em Elaboração">(Erro ao Enviar)</option>
                            <option value="Em Análise">Em Análise</option>
                            <option value="Aprovado">Aprovado</option>
                            <option value="Rejeitado">Rejeitado</option>
                            <option value="Excluído">Excluído</option>
                        </select>
                    </div>
                    <div class="col-sm-2 col-12">
                        <h6 class="mb-0">Fase</h6>
                        <select [(ngModel)]="criterioFase" class="col-12" name="criterioFase">
                            <option value="null"></option>

                            <option value="Em Análise pelo Analista">Em Análise pelo Analista</option>
                            <option value="Em Análise pelo Gerente">Em Análise pelo Gerente</option>
                            <option value="Em Análise pelo Chefe de Departamento">Em Análise pelo Chefe de
                                Departamento
                            </option>
                            <option value="#PROCESSAMENTO#">(Fases de Processamento)</option>
                            <option value="Em Elaboração">(Erro ao Enviar)</option>
                            <option value="Expedido">Expedido</option>
                            <option value="Excluído">Excluído</option>
                        </select>
                    </div>
                    <div class="col-sm-4 col-12">
                        <h6 class="mb-0">Comprador / Razão Social</h6>
                        <input class="col-12" [(ngModel)]="criterioComprador" name="criterioComprador">
                    </div>
                    <div class="col-sm-2 col-12">
                        <h6 class="mb-0">Proposta</h6>
                        <input class="col-12" [(ngModel)]="criterioProposta" name="criterioProposta">
                    </div>
                    <div class="col-sm-2 col-12">
                        <h6 class="mb-0">Ano</h6>
                        <input class="col-12" [(ngModel)]="criterioAno" name="criterioAno">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="d-flex col-12 justify-content-end">
            <button class="btn" (click)="alternarPesquisa()" type="button">
                <i class="fa fa-search-minus me-1" aria-hidden="true" *ngIf="exibePesquisaAvancada"></i>
                <i class="fa fa-search-plus me-1" aria-hidden="true" *ngIf="!exibePesquisaAvancada"></i>
                {{ exibePesquisaAvancada ? 'Pesquisa Simplificada' : 'Pesquisa Avançada'}}
            </button>
            <button class="btn btn-primary" (click)="pesquisar()" type="submit">
                <i class="fa fa-search me-1" aria-hidden="true"></i>
                Pesquisar
            </button>
        </div>
    </div>
</form>

<br>

<p *ngIf="msg">{{msg}}</p>

<div class="table-responsive" *ngIf="!msg">
    <table class="table table-hover">
        <thead>
        <tr>
            <th scope="col">Instituição Financeira</th>
            <th scope="col">Protocolo Aditivo</th>
            <th scope="col">Situação<br>(Fase)</th>
            <th scope="col">Proposta</th>
            <th scope="col">Ano</th>
            <th scope="col">PAC</th>
            <th scope="col">Comprador</th>
            <th scope="col">Razão Social</th>
        </tr>
        </thead>
        <tbody>

        <tr class="clickable" *ngFor="let aditivo of aditivos" (click)="onVisualizarClick(aditivo)">
            <td title="CNPJ: {{aditivo?.instituicaoFinanceiraCnpj | bnMask:'CNPJ'}}">{{aditivo?.instituicaoFinanceiraSigla}}</td>
            <td>{{aditivo?.datProtocolo | date: 'dd/MM/yyyy'}}</td>
            <td title="Id: {{aditivo?.situacaoId}}">
                {{aditivo?.situacaoNomeExterno}}<br>
                ({{aditivo?.situacaoFase}})
            </td>
            <td>{{aditivo?.propostaNumero}}</td>
            <td>{{aditivo?.propostaAno}}</td>
            <td>{{aditivo?.numeroPacStr | bnMask:'99.999-9'}}</td> <!-- 00.799-4 -->
            <td>{{aditivo?.compradorCnpjCpf | bnMask:'CNPJCPF'}}</td>
            <td>{{aditivo?.compradorNome}}</td>
        </tr>

        </tbody>
        <tfoot>
        <tr>
            <td colspan="5">Exibindo {{aditivos.length}} registros</td>
        </tr>
        </tfoot>
    </table>
</div>


<!--
<h5>Aditivos</h5>
{{aditivos | json}}
-->
